import type { NavigateFunction } from 'react-router-dom';

export function buildThreadSearchParams(current: URLSearchParams, threadId: string | null): URLSearchParams {
  const next = new URLSearchParams(current);
  if (threadId) {
    next.set('thread', threadId);
  } else {
    next.delete('thread');
  }
  return next;
}

export function syncThreadInUrl(
  navigate: NavigateFunction,
  pathname: string,
  searchParams: URLSearchParams,
  threadId: string | null,
  replace: boolean
): void {
  const next = buildThreadSearchParams(searchParams, threadId);
  const search = next.toString();
  navigate({ pathname, search: search ? `?${search}` : '' }, { replace });
}

